import { Component, OnInit, HostBinding, Output, EventEmitter, Input, ViewChild, TemplateRef, ComponentFactoryResolver, Optional, ChangeDetectorRef, Inject, LOCALE_ID } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DataTableComponent } from '@farris/ui-datatable';
import { DialogComponent } from '@farris/ui-dialog';
import { ApprovalItemEntity } from './entities/approval-item.entity';
import { HttpService } from '@ecp-caf/caf-common';
import { MessagerService } from '@farris/ui-messager';
import { map } from 'rxjs/operators';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { EditorTypes } from '@farris/ui-datagrid-editors';
import { DatagridComponent } from '@farris/ui-datagrid';
import { ProcessDeUtil } from '../../domain/process-de-util';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'app-approvel-items',
  templateUrl: './approvel-items.component.html',
  styleUrls: ['./approvel-items.component.css'],
  providers: [
     WfLocalePipe,
  ]
})
export class ApprovelItemsComponent implements OnInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @Input()
  set value(items: any[]) {
    if (items && items.length > 0) {
      for (const item of items) {
        const approval = new ApprovalItemEntity();
        approval.value = item.Value;
        approval.text = item.Text;
        approval.workFlowAction = item.WorkFlowAction;
        approval.isDefault = item.IsDefault;

        if (item.commentNecessary === null || item.commentNecessary === undefined) {
          approval.commentNecessary = (item.Value === 'Back' ? true : false);
        } else {
          approval.commentNecessary = item.commentNecessary;
        }

        approval.certification = item.certification ? item.certification : false;
        approval.attachmentNecessary = item.attachmentNecessary ? item.attachmentNecessary : false;
        approval.signatureNecessary = item.signatureNecessary ? item.signatureNecessary : false;
        approval.defaultComment = item.defaultComment ? JSON.parse(item.defaultComment) : null;
        this.data.push(approval);
      }
    }
  }

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  @ViewChild('actionsTable') actionsTable: DatagridComponent;
  @ViewChild('actionsDialog') actionsDialog: DialogComponent;
  @ViewChild('grid') grid: DatagridComponent;

  modalConfig = {
    title: this.localePipe.transform('component.approvelItems.approvalOptions'),
    width: 1100,
    height: 515,
    showButtons: true
  };

  workFlowActions: any[] = [
    { text: this.localePipe.transform('component.approvelItems.forward'), value: 'Forward' },
    { text: this.localePipe.transform('component.approvelItems.backward'), value: 'Backward' },
    { text: this.localePipe.transform('component.approvelItems.abort'), value: 'Abort' }];

  columns = [
    {
      field: 'value', width: 80, title: this.localePipe.transform('component.approvelItems.value'),
    },
    { field: 'text', width: 80, title:  this.localePipe.transform('component.approvelItems.text')},
    {
      field: 'workFlowAction', width: 80, title: this.localePipe.transform('component.approvelItems.workFlowAction'),
      formatter: {
        type: 'enum',
        options: { valueField: 'value', textField: 'text', data: this.workFlowActions}
      },
      editor: {
        type: EditorTypes.COMBOLIST,
        options: { valueField: 'value', textField: 'text', data: this.workFlowActions, idField: 'value', panelHeight: 'auto' }
      },
      validators: [
        { type: 'required', messager: '必填' }
      ]
    },
    {
      field: 'isDefault', width: 60, title: this.localePipe.transform('component.approvelItems.isDefault'),
      editor: {
        type: EditorTypes.SWITCH,
        options: {}
      },
      formatter: { type: 'boolean', options: { trueText: this.localePipe.transform('component.approvelItems.yes'), falseText: this.localePipe.transform('component.approvelItems.no') } },
      validators: [
        { type: 'required', messager: '必填' }
      ]
    },
    {
      field: 'commentNecessary', width: 60, title: this.localePipe.transform('component.approvelItems.commentNecessary'),
      editor: {
        type: EditorTypes.SWITCH,
        options: {}
      },
      formatter: { type: 'boolean', options: { trueText: this.localePipe.transform('component.approvelItems.yes'), falseText: this.localePipe.transform('component.approvelItems.no') } },
      validators: [
        { type: 'required', messager: '必填' }
      ]
    },
    {
      field: 'attachmentNecessary', width: 60, title: this.localePipe.transform('component.approvelItems.attachmentNecessary'),
      editor: {
        type: EditorTypes.SWITCH,
        options: {}
      },
      formatter: { type: 'boolean', options: { trueText: this.localePipe.transform('component.approvelItems.yes'), falseText: this.localePipe.transform('component.approvelItems.no') } },
      validators: [
        { type: 'required', messager: '必填' }
      ]
    },
    {
      field: 'certification', width: 60, title: this.localePipe.transform('component.approvelItems.certification'),
      editor: {
        type: EditorTypes.SWITCH,
        options: {}
      },
      formatter: { type: 'boolean', options: { trueText: this.localePipe.transform('component.approvelItems.yes'), falseText: this.localePipe.transform('component.approvelItems.no') } },
      validators: [
        { type: 'required', messager: '必填' }
      ]
    },
    {
      field: 'signatureNecessary', width: 60, title: this.localePipe.transform('component.approvelItems.signatureNecessary'),
      editor: {
        type: EditorTypes.SWITCH,
        options: {}
      },
      formatter: { type: 'boolean', options: { trueText: this.localePipe.transform('component.approvelItems.yes'), falseText: this.localePipe.transform('component.approvelItems.no') } },
      validators: [
      ]
    },
    {
      field: 'defaultComment', isMultilingualField: true, width: 70, title: this.localePipe.transform('component.approvelItems.defaultComment'),
      editor: {
        type: EditorTypes.LANGUAGETEXTBOX, options: {
            languages: [
                { code: 'zh-CHS', name: this.localePipe.transform('component.approvelItems.zh-CHS') },
                { code: 'zh-CHT', name: this.localePipe.transform('component.approvelItems.zh-CHT') },
                { code: 'en', name: this.localePipe.transform('component.approvelItems.en') }
            ]
        }
      }
    }
  ];

  data: ApprovalItemEntity[] = [];

  // 审批动作
  actions: any[];
  actionsCols = [
    { title: this.localePipe.transform('component.approvelItems.value'), field: 'code', width: 80 },
    { title: this.localePipe.transform('component.approvelItems.text'), field: 'name', width: 90 }];

  constructor(
    private message: MessagerService,
    private util: ProcessDeUtil,
    private http: HttpService,
    private uiState: ProcessDesignerUIState,
    private resolver: ComponentFactoryResolver,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
    this.getActionsList();
  }

  clickOK() {
    this.grid.endCellEdit();
    if (this.validator()) {
      const actionList = [];
      // 将多语的默认意见转成String
      for (const action of this.data) {
        if (action.defaultComment != null) {
          action.defaultComment = JSON.stringify(action.defaultComment);
        }
        actionList.push(action);
      }
      console.log(actionList);
      const object = { value: actionList, parameters: null };
      this.submitModal.emit(object);
    }
  }

  clickCancel() {
    this.closeModal.emit();
  }

  private validator(): boolean {
    if (this.data.findIndex(d => !d.workFlowAction) > -1) {
      this.message.warning(this.localePipe.transform('component.approvelItems.workFlowActionNotNull'));
      return false;
    }
    return true;
  }

  selectChanged(data: any) { }

  deleteRow() {
    this.grid.endCellEdit();
    if (this.grid.selectedRow && this.grid.selectedRow.data) {
      const i = this.data.findIndex(d => d.value === this.grid.selectedRow.data.value);
      this.data.splice(i, 1);
      this.grid.loadData(this.data);
    } else {
      this.message.info(this.localePipe.transform('component.approvelItems.deleteRow'));
    }
  }

  private getActionsList() {
    let url = this.util.getApprovalActionWebApi() + '?';
    if (this.uiState.bizActivityId) {
      url += `bizActivityId=${this.uiState.bizActivityId}`;
    } else {
      url += `bizActivityId=`;
    }

    this.http.get(url).subscribe((data: any) => {
        data = data.filter(a => this.actionValidate(a));
        this.actions = data;
        if(this.actions && this.data) {
          this.data.forEach(d => {
            let action = this.actions.find(action => action.code === d.value);
            if(action) {
              d.text = action.name;
            }
          })
        }
      });
  }

  actionsSelect() {
    const selections: any[] = this.actionsTable.checkeds;
    if (selections && selections.length > 0) {
      selections.forEach(action => {
        const item = new ApprovalItemEntity(action.data.code, action.data.name, action.data.workFlowAction);
        const index = this.data.findIndex(act => act.value === action.data.code);
        if (index > -1) {
          this.data.splice(index, 1);
        }
        this.data.push(item);
      });
      this.grid.loadData(this.data);
    }
    // 2023-6-13 关闭前清空已选数据
    this.actionsTable.clearCheckeds(true);
    this.actionsDialog.close();
  }

  SelectCancel() {
    // 2023-6-13 关闭前清空已选数据
    this.actionsTable.clearCheckeds(true);
    this.actionsDialog.close();
  }

  private actionValidate(action: any) {
    const arr = ['ViewBizLog', 'ViewFlowChart', 'AssignUser', 'Claim', 'Unclaim', 'Retrieve', 'Resubmit', 'Obsolete', 'Transfer', 'AddSignFront', 'ViewExecuteForm'];
    return arr.indexOf(action.code.trim()) === -1;
  }
}

export class ApprovelItemsConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any[]): string {
    if (data && data.length > 0) {
      return this.localePipe.transform('component.approvelItems.set');
    } else {
      return this.localePipe.transform('component.approvelItems.notSet');
    }
  }
}
